import moment from "moment";

function validateAge(birthday, showFallback, format = "DD/MM/YYYY", minimumAge = 18) {
  const dob = moment(birthday, format, true);
  const now = moment();
  const difference = now.diff(dob, "year", true);
  console.log("birthday");
  console.log("dob", dob);
  console.log("difference", difference);
  console.log("format", format);
  console.log("minimumAge", minimumAge);
  return isNaN(difference) ? undefined : difference >= minimumAge && difference < 120;
}

export default validateAge;